<template>
  <q-page padding>
    <div class="relative-position loader">
      <event-attendees :event-id="eventId"></event-attendees>
    </div>
  </q-page>
</template>

<script>
import EventAttendees from '../../../components/events/attendees'

export default {
  components: { EventAttendees },
  computed: {
    eventId () {
      if (this.$route && this.$route.params && this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
      return null
    }
  }
}
</script>
